// @ts-nocheck

import classNames from 'classnames';
import * as React from 'react';
import Tooltip from '../core/Tooltip';
// Parent component controls how it changes onClick with callback,
// and parent passes in which way is toggled declaratively via 'isRight' prop
export type ToggleProps = {
  // 'isRight' determines the side the toggle is set to.
  // If true, circle will be at right, if false will be at left.
  isRight: boolean;
  // onClick is triggered whenever the toggle area is clicked anywhere.
  // The parent can then decide how to handle, and pass in new 'isRight' prop
  // to the toggle if it wants it to visually flip the toggle.
  onClick: () => void;
  // For QA to use when triggering toggle event.
  // Actual 'data-testid' created will prefixed with "toggle__".
  testid: string;
  // Class to be applied to outer-most parent div. Any style changes to apply
  // to other toggle-specific classes, such as toggle__bar or toggle__label
  // should then be done nested inside this parent class.
  className?: string;
  disabled?: boolean;
  // Text to be displayed on the left side of the toggle.
  leftLabel?: string;
  // Text to be displayed on the right side of the toggle.
  rightLabel?: string;
  // A checkmark or an 'X' can appear inside the toggle itself.
  // If both labels are passed in, 'showIcons' will default to false.
  // If either right or left label not passed in, 'showIcons' will default to true.
  showIcons?: boolean;
  // Optional tooltip for toggle's right label
  tooltip?: string | React.ReactElement<any>;
};
export default class Toggle extends React.PureComponent<ToggleProps> {
  render() {
    const { isRight, leftLabel, rightLabel, onClick, className, disabled, tooltip } = this.props;

    let showIcons = this.props.showIcons;

    if (showIcons === undefined) {
      // if showIcons prop not specified, default to showing for toggles missing
      // either label, and hide for toggles with both labels.
      showIcons = !this.props.rightLabel || !this.props.leftLabel;
    }

    return (
      <div
        onClick={disabled ? null : onClick}
        bindClickEvent={true}
        className={classNames('toggle__outer-container', className)}
        data-testid={`toggle__${this.props.testid}`}
      >
        <span className="toggle__label">{leftLabel}</span>
        <div
          className={classNames('toggle__inner-container', {
            'h_mstart-10': leftLabel,
            'h_mend-10': rightLabel,
          })}
        >
          <div
            className={classNames('toggle__circle', {
              'toggle__to-right': isRight,
              'toggle__toggle-disabled': disabled,
            })}
          />
          {showIcons && (
            <i
              className={classNames('material-icons toggle__icon', {
                'toggle__to-right': isRight,
              })}
            >
              {isRight ? 'done' : 'clear'}
            </i>
          )}
          <div
            className={classNames('toggle__bar', {
              'toggle__to-right': isRight,
              'toggle__toggle-disabled': disabled,
            })}
          />
        </div>
        <span className="toggle__label">{rightLabel}</span>
        {tooltip && <Tooltip body={tooltip} infoIconClassName="h_va-u" />}
      </div>
    );
  }
}
